import React, { Component } from 'react';

import { Container } from './style';
import { Modal } from 'semantic-ui-react';

import Close from './../../assets/images/amigoo_close.svg';
import Error from './../../assets/images/amigoo_error.svg';
import Check from './../../assets/images/amigoo_check.svg';

class Alert extends Component {
  /**
   * Constructor.
   *
   * @param props
   */
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      params: {
        success: true,
        title: '',
        subtitle: '',
      },
    };
  }

  /**
   * Toggle Modal (Abrir/Fechar).
   *
   * @param params
   * @returns {Promise<void>}
   */
  toggleModal = async params => {
    await this.setState(prevState => ({
      open: !prevState.open,
      params,
    }));
  };

  render() {
    const { open, params } = this.state;

    return (
      <Modal open={open}>
        <Container>
          <img
            src={Close}
            alt="Fechar Modal"
            onClick={() => this.toggleModal({})}
            className={'header__close'}
          />
          {
            (params.success) ? (
              <img
                src={Check}
                alt="Sucesso"
                className={'header__image'}
              />
            ) : (
              <img
                src={Error}
                alt="Error"
                className={'header__image'}
              />
            )
          }

          <hgroup>
            <h1>{params.title}</h1>
            <h6>{params.subtitle}</h6>
          </hgroup>
        </Container>
      </Modal>
    );
  }
}

export default Alert;